import Papa from 'papaparse';
import type { RawRows } from './types';

// Quote-aware CSV parser (Tech Spec §6.7). papaparse's default quote handling is
// RFC-4180-compliant, so no custom quote config is needed. We parse to raw arrays
// (header: false) because the header row is detected later by findHeaderRow.

export async function parseCsv(file: File): Promise<RawRows> {
	const text = await file.text();
	const clean = text.replace(/^\uFEFF/, ''); // strip BOM (Functional Spec §3.7)

	const result = Papa.parse<string[]>(clean, {
		header: false,
		skipEmptyLines: 'greedy',
		dynamicTyping: false,
	});

	if (result.errors.length > 0 && result.data.length === 0) {
		throw new Error(`CSV parse failed: ${result.errors[0].message}`);
	}

	return result.data.map((row) =>
		row.map((cell) => (cell == null ? '' : String(cell)))
	);
}
